import React, { useState } from "react";

// Inline SVG icons (matching formmodeltest.js)
const icons = {
   user: (
      <svg
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
         />
      </svg>
   ),
   truck: (
      <svg
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.125-.504 1.125-1.125V14.25m-17.25 4.5v-1.875a3.375 3.375 0 013.375-3.375h9.75a3.375 3.375 0 013.375 3.375v1.875m-17.25 4.5h15.75M6 6.375h12M6 10.125h12M6 13.875h12"
         />
      </svg>
   ),
   calendar: (
      <svg
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0H21"
         />
      </svg>
   ),
   check: (
      <svg
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
         />
      </svg>
   ),
   document: (
      <svg
         width="20"
         height="20"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
         />
      </svg>
   ),
   link: (
      <svg
         width="16"
         height="16"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-4.5 0V6.375c0-.621.504-1.125 1.125-1.125h4.125c.621 0 1.125.504 1.125 1.125V10.5m-4.5 0L19.5 4.5"
         />
      </svg>
   ),
   photo: (
      <svg
         width="22"
         height="22"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
         />
      </svg>
   ),
   exclamation: (
      <svg
         width="24"
         height="24"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
         />
      </svg>
   ),
   chevron: (
      <svg
         width="16"
         height="16"
         fill="none"
         stroke="currentColor"
         strokeWidth="1.5"
         viewBox="0 0 24 24"
      >
         <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
   ),
};

// DocumentImage component for modal
function DocumentImage({ url, title, placeholder, setSelectedItem }) {
   if (!url) return null;
   return (
      <div className="document-image-container">
         <div className="document-image-header">
            <h5>{title}</h5>
            <button
               className="expand-button"
               onClick={() => setSelectedItem && setSelectedItem({ url, title })}
            >
               🔍
            </button>
         </div>
         <img
            src={url}
            alt={title}
            className="document-image"
            onClick={() => setSelectedItem && setSelectedItem({ url, title })}
            onError={(e) => {
               e.target.style.display = "none";
               e.target.nextSibling.style.display = "flex";
            }}
         />
         <div className="image-error" style={{ display: "none" }}>
            <span>📄</span>
            <p>{placeholder || "Image not available"}</p>
         </div>
      </div>
   );
}

// Helper functions
function getFieldIcon(key) {
   const keyLower = key.toLowerCase();
   if (keyLower.includes("driver") || keyLower.includes("name")) return icons.user;
   if (keyLower.includes("truck") || keyLower.includes("vehicle") || keyLower.includes("equipment"))
      return icons.truck;
   if (keyLower.includes("date") || keyLower.includes("time")) return icons.calendar;
   if (keyLower.includes("status") || keyLower.includes("complete")) return icons.check;
   return icons.document;
}

function formatKey(key) {
   return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}

function formatFormType(type) {
   return type ? type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) : "";
}

// Main FormModal component
const FormModal = ({ selectedForm, showModal, onClose }) => {
   const [expandedImage, setExpandedImage] = useState(null);

   if (!showModal || !selectedForm) return null;

   const formDataObj = selectedForm.form_data
      ? typeof selectedForm.form_data === "string"
         ? JSON.parse(selectedForm.form_data)
         : selectedForm.form_data
      : {};

   const data = formDataObj;
   const isDriverVerification = selectedForm.form_type === "driver_verification";
   const isDispatch = selectedForm.form_type === "dispatch";

   // Group fields by category
   const getDriverInfoFields = () => {
      if (isDriverVerification) {
         return {
            "Driver First Name": data["Driver First Name"],
            "Driver Last Name": data["Driver Last Name"],
            "Driver Email": data["Driver Email"],
            "Driver Phone": data["Driver Phone"],
            Location: data["Location"],
            "Empty Status": data["Empty Status"],
            "Empty Time": data["Empty Time"],
            "Empty Location": data["Empty Location"],
            "SMS Consent": data["SMS Consent"],
         };
      } else if (isDispatch) {
         return {
            "Driver First Name": data["Driver First Name"],
            "Driver Last Name": data["Driver Last Name"],
            "Driver Phone Number": data["Driver Phone Number"],
            "Driver Type": data["Driver Type"],
            "Driver Location": data["Driver Location"],
            "Driver Consent": data["Driver Consent"],
         };
      }
      return {};
   };

   const getDispatcherInfoFields = () => {
      if (isDispatch) {
         return {
            "Dispatcher First Name": data["Dispatcher First Name"],
            "Dispatcher Last Name": data["Dispatcher Last Name"],
            "Dispatcher Email": data["Dispatcher Email"],
            "After Hours Phone": data["After Hours Phone"],
            "USDOT Number": data["USDOT Number"],
         };
      }
      return {};
   };

   const getEquipmentInfoFields = () => {
      if (isDispatch) {
         return {
            "Equipment Type": data["Equipment Type"],
            "Other Equipment": data["Other Equipment"],
            "Truck Number": data["Truck Number"],
            "Trailer Number": data["Trailer Number"],
            "Truck Vin": data["Truck Vin"],
            "Truck License": data["Truck License"],
            "Truck License State": data["Truck License State"],
         };
      }
      return {};
   };

   const getDocumentFields = () => {
      const documentKeys = Object.keys(data).filter((key) => {
         const value = data[key];
         return (
            typeof value === "string" &&
            (value.startsWith("http://") || value.startsWith("https://")) &&
            [
               "jpg",
               "jpeg",
               "png",
               "gif",
               "bmp",
               "webp",
               "svg",
               "PNG",
               "JPG",
               "JPEG",
               "GIF",
               "BMP",
               "WEBP",
               "SVG",
            ].includes(value.split(".").pop().toLowerCase())
         );
      });

      const documents = {};
      documentKeys.forEach((key) => {
         documents[key] = data[key];
      });
      return documents;
   };

   const getVerificationFields = () => {
      return {
         "Email Verification": data["Email Verification"],
         "Phone Verification": data["Phone Verification"],
         "IP Verification": data["IP Verification"],
         "Client IP": data["Client IP"],
      };
   };

   const getMetaFields = () => {
      return {
         timestamp: data["timestamp"],
         frontConversation: data["frontConversation"],
         groupId: data["groupId"],
         "Visitor ID": data["Visitor ID"],
         applicant_Id: selectedForm.applicant_Id,
      };
   };

   const renderValue = (value, key) => {
      if (value === null || value === undefined) {
         return <span className="badge badge-secondary">Not provided</span>;
      }
      if (value === "") {
         return <span className="badge badge-secondary">Empty</span>;
      }
      if (typeof value === "boolean") {
         return (
            <span className={`badge ${value ? "badge-success" : "badge-danger"}`}>
               {value ? "✅ Yes" : "❌ No"}
            </span>
         );
      }
      if (Array.isArray(value) && value.every((v) => typeof v === "string")) {
         return (
            <div>
               {value.map((item, idx) => (
                  <span key={idx} className="badge badge-info mr-1 mb-1">
                     {item}
                  </span>
               ))}
            </div>
         );
      }
      if (
         typeof value === "string" &&
         (value.startsWith("http://") || value.startsWith("https://"))
      ) {
         const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(
            value.split(".").pop().toLowerCase()
         );
         if (isImage) return null; // Images are handled in their own section
         const fileName = value.split("/").pop() || "View File";
         return (
            <a
               href={value}
               target="_blank"
               rel="noopener noreferrer"
               className="badge badge-primary"
            >
               {icons.link} {fileName}
            </a>
         );
      }

      // Special styling for specific field types
      if (key && key.toLowerCase().includes("equipment")) {
         const colorMap = {
            "Dry Van": "badge-primary",
            Reefer: "badge-info",
            Flatbed: "badge-warning",
         };
         return <span className={`badge ${colorMap[value] || "badge-secondary"}`}>{value}</span>;
      }

      if (key === "Empty Status" || key === "Is Driver Empty Now") {
         return (
            <span className={`status-indicator ${value === "Yes" ? "empty" : "occupied"}`}>
               {value}
            </span>
         );
      }

      if (key === "Driver Consent") {
         return (
            <span className={`consent-status ${value === "Yes" ? "approved" : "denied"}`}>
               {value}
            </span>
         );
      }

      if (typeof value === "object") return <FormDataDisplay data={value} nested={true} />;
      return <span>{String(value)}</span>;
   };

   const FormDataDisplay = ({ data, nested = false }) => {
      const [openSections, setOpenSections] = useState({});

      const toggleSection = (key) => {
         setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
      };

      if (!data) return null;

      if (Array.isArray(data)) {
         return (
            <div className="row">
               {data.map((item, idx) => (
                  <div key={idx} className="col-12 mb-3">
                     <div className="card data-card">
                        <div className="card-body">
                           <FormDataDisplay data={item} nested={true} />
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         );
      }

      const allKeys = Object.keys(data);
      const imageKeys = allKeys.filter((key) => {
         const value = data[key];
         return (
            typeof value === "string" &&
            (value.startsWith("http://") || value.startsWith("https://")) &&
            ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(
               value.split(".").pop().toLowerCase()
            )
         );
      });

      const fieldsToRender = Object.entries(data).filter(([key, value]) => {
         return !imageKeys.includes(key);
      });

      return (
         <div className={nested ? "row" : "row"}>
            {fieldsToRender.map(([key, value]) => {
               const isObjectOrArray = typeof value === "object" && value !== null;

               if (!nested && isObjectOrArray) {
                  return (
                     <div key={key} className="col-12 mb-3">
                        <div className="card section-card">
                           <div
                              className="card-header section-header"
                              onClick={() => toggleSection(key)}
                           >
                              <div className="d-flex align-items-center justify-content-between">
                                 <div className="d-flex align-items-center">
                                    <div className="icon-container me-3">{getFieldIcon(key)}</div>
                                    <h5 className="mb-0 section-title">{formatKey(key)}</h5>
                                 </div>
                                 <div
                                    className={`chevron ${openSections[key] ? "chevron-open" : ""}`}
                                 >
                                    {icons.chevron}
                                 </div>
                              </div>
                           </div>
                           {openSections[key] && (
                              <div className="card-body section-body">
                                 <FormDataDisplay data={value} nested={true} />
                              </div>
                           )}
                        </div>
                     </div>
                  );
               }

               const renderedValue = renderValue(value, key);
               if (renderedValue === null) return null;

               return (
                  <div key={key} className="col-md-6 col-6 mb-3" style={{ textAlign: "center" }}>
                     <div className="card field-card h-fit" style={{ border: "none" }}>
                        <div className="card-body">
                           <div className="d-flex align-items-start">
                              <div className="field-icon me-2">{getFieldIcon(key)}</div>
                              <div className="flex-grow-1">
                                 <div className="field-label">{formatKey(key)}</div>
                                 <div className="field-value">{renderedValue}</div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               );
            })}
         </div>
      );
   };

   const renderInfoSection = (title, fields, icon = icons.document, color) => {
      const validFields = Object.entries(fields).filter(
         ([key, value]) => value !== null && value !== undefined && value !== ""
      );
      if (validFields.length === 0) return null;

      // Only apply theme class if not the DriverLicenseCard (i.e., not the first Driver Information section)
      let themeClass = "";
      // Only add themeClass if NOT the first Driver Information section (i.e., not isDriverVerification && title === 'Driver Information')
      if (!(isDriverVerification && title === "Driver Information")) {
         if (isDriverVerification) themeClass = "driver-theme";
         else if (isDispatch) themeClass = "dispatch-theme";
      }

      return (
         <div className={`info-section${themeClass ? " " + themeClass : ""}`}>
            <h4 style={color ? { color } : {}}>
               {icon} {title}
            </h4>
            <div className="info-details">
               {validFields.map(([key, value]) => (
                  <p key={key}>
                     <strong>{formatKey(key)}:</strong> {renderValue(value, key)}
                  </p>
               ))}
            </div>
         </div>
      );
   };

   const renderVerificationSection = (color) => {
      const verificationFields = getVerificationFields();
      const hasVerifications = Object.values(verificationFields).some(
         (v) => v && typeof v === "object"
      );

      if (!hasVerifications) return null;

      // Only apply theme class for theme sections, not for DriverLicenseCard
      let themeClass = "";
      if (isDriverVerification) themeClass = "driver-theme";
      else if (isDispatch) themeClass = "dispatch-theme";

      return (
         <div className={`info-section verification-results${themeClass ? " " + themeClass : ""}`}>
            <h4 style={color ? { color } : {}}>{icons.check} Verification Results</h4>
            <div className="info-details">
               <div className="verification-grid">
                  {verificationFields["Email Verification"] && (
                     <div className="verification-item email-verification">
                        <h5>Email Verification</h5>
                        <p>
                           <strong>Status:</strong>{" "}
                           <span
                              className={`verification-status ${verificationFields["Email Verification"].success ? "success" : "failed"}`}
                           >
                              {verificationFields["Email Verification"].success
                                 ? "Valid"
                                 : "Invalid"}
                           </span>
                        </p>
                        <p>
                           <strong>Message:</strong>{" "}
                           {verificationFields["Email Verification"].message}
                        </p>
                        {verificationFields["Email Verification"].success && (
                           <>
                              <p>
                                 <strong>Deliverability:</strong>{" "}
                                 {verificationFields["Email Verification"].deliverability}
                              </p>
                              <p>
                                 <strong>Fraud Score:</strong>{" "}
                                 {verificationFields["Email Verification"].fraud_score}
                              </p>
                              <p>
                                 <strong>Disposable:</strong>{" "}
                                 {verificationFields["Email Verification"].disposable
                                    ? "Yes"
                                    : "No"}
                              </p>
                           </>
                        )}
                     </div>
                  )}
                  {verificationFields["Phone Verification"] && (
                     <div className="verification-item phone-verification">
                        <h5>Phone Verification</h5>
                        <p>
                           <strong>Status:</strong>{" "}
                           <span
                              className={`verification-status ${verificationFields["Phone Verification"].success ? "success" : "failed"}`}
                           >
                              {verificationFields["Phone Verification"].success
                                 ? "Valid"
                                 : "Invalid"}
                           </span>
                        </p>
                        <p>
                           <strong>Message:</strong>{" "}
                           {verificationFields["Phone Verification"].message}
                        </p>
                        {verificationFields["Phone Verification"].success && (
                           <>
                              <p>
                                 <strong>Formatted:</strong>{" "}
                                 {verificationFields["Phone Verification"].formatted}
                              </p>
                              <p>
                                 <strong>Carrier:</strong>{" "}
                                 {verificationFields["Phone Verification"].carrier}
                              </p>
                              <p>
                                 <strong>Line Type:</strong>{" "}
                                 {verificationFields["Phone Verification"].line_type}
                              </p>
                              <p>
                                 <strong>Country:</strong>{" "}
                                 {verificationFields["Phone Verification"].country}
                              </p>
                              <p>
                                 <strong>Fraud Score:</strong>{" "}
                                 {verificationFields["Phone Verification"].fraud_score}
                              </p>
                           </>
                        )}
                     </div>
                  )}
                  {verificationFields["IP Verification"] && (
                     <div className="verification-item ip-verification">
                        <h5>IP Verification</h5>
                        <p>
                           <strong>Status:</strong>{" "}
                           <span
                              className={`verification-status ${verificationFields["IP Verification"].success ? "success" : "failed"}`}
                           >
                              {verificationFields["IP Verification"].success ? "Valid" : "Invalid"}
                           </span>
                        </p>
                        <p>
                           <strong>Client IP:</strong>{" "}
                           <code>{verificationFields["Client IP"]}</code>
                        </p>
                        <p>
                           <strong>Country:</strong>{" "}
                           {verificationFields["IP Verification"].country_code || "N/A"}
                        </p>
                        <p>
                           <strong>Region:</strong>{" "}
                           {verificationFields["IP Verification"].region || "N/A"}
                        </p>
                        <p>
                           <strong>City:</strong>{" "}
                           {verificationFields["IP Verification"].city || "N/A"}
                        </p>
                        <p>
                           <strong>ISP:</strong> {verificationFields["IP Verification"].ISP}
                        </p>
                        <p>
                           <strong>Fraud Score:</strong>{" "}
                           {verificationFields["IP Verification"].fraud_score}
                        </p>
                        <p>
                           <strong>VPN:</strong>{" "}
                           {verificationFields["IP Verification"].vpn ? "Yes" : "No"}
                        </p>
                        <p>
                           <strong>Proxy:</strong>{" "}
                           {verificationFields["IP Verification"].proxy ? "Yes" : "No"}
                        </p>
                        <p>
                           <strong>Connection:</strong>{" "}
                           {verificationFields["IP Verification"].connection_type}
                        </p>
                     </div>
                  )}
               </div>
            </div>
         </div>
      );
   };

   const renderDocumentsSection = (color) => {
      const documents = getDocumentFields();
      const documentEntries = Object.entries(documents);

      if (documentEntries.length === 0) return null;

      // Only apply theme class for theme sections, not for DriverLicenseCard
      let themeClass = "";
      if (isDriverVerification) themeClass = "driver-theme";
      else if (isDispatch) themeClass = "dispatch-theme";

      return (
         <div className={`info-section documents-section${themeClass ? " " + themeClass : ""}`}>
            <h4 style={color ? { color } : {}}>{icons.photo} Documents</h4>
            <div className="documents-grid">
               {documentEntries.map(([key, url]) => (
                  <DocumentImage
                     key={key}
                     url={url}
                     title={formatKey(key)}
                     setSelectedItem={setExpandedImage}
                  />
               ))}
            </div>
         </div>
      );
   };

   // DriverLicenseCard subcomponent for driver verification forms
   function DriverLicenseCard({ info }) {
      function formatLatLng(location) {
         if (!location || typeof location !== "string") return "N/A";
         const match = location.match(/Lat:\s*([\d.-]+),\s*Lng:\s*([\d.-]+)/i);
         if (!match) return location;
         const lat = parseFloat(match[1]).toFixed(2);
         const lng = parseFloat(match[2]).toFixed(2);
         return `Lat: ${lat}, Lng: ${lng}`;
      }

      return (
         <div className="driver-license-card dl-horizontal">
            <div className="dl-header">
               <span className="dl-title">DRIVER INFORMATION</span>
            </div>
            <div className="dl-body">
               <div className="dl-avatar">
                  <svg
                     width="80"
                     height="80"
                     fill="none"
                     stroke="#2563eb"
                     strokeWidth="1.5"
                     viewBox="0 0 24 24"
                  >
                     <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                     />
                  </svg>
               </div>
               <div className="dl-info-grid">
                  <div>
                     <span className="dl-label">Name:</span>{" "}
                     <span className="dl-value">
                        {info["Driver First Name"]} {info["Driver Last Name"]}
                     </span>
                  </div>
                  <div>
                     <span className="dl-label">Email:</span>{" "}
                     <span className="dl-value">{info["Driver Email"] || "Not Provided"}</span>
                  </div>
                  <div>
                     <span className="dl-label">Phone:</span>{" "}
                     <span className="dl-value">{info["Driver Phone"] || "N/A"}</span>
                  </div>
                  <div>
                     <span className="dl-label">Location:</span>{" "}
                     <span className="dl-value">{formatLatLng(info["Location"])}</span>
                  </div>
                  <div>
                     <span className="dl-label">Empty Status:</span>{" "}
                     <span
                        className={`dl-badge ${info["Empty Status"] === "Yes" ? "dl-badge-yes" : "dl-badge-no"}`}
                     >
                        {info["Empty Status"] || "N/A"}
                     </span>
                  </div>
                  <div>
                     <span className="dl-label">Empty Time:</span>{" "}
                     <span className="dl-value">{info["Empty Time"] || "N/A"}</span>
                  </div>
                  <div>
                     <span className="dl-label">Empty Location:</span>{" "}
                     <span className="dl-value">{info["Empty Location"] || "N/A"}</span>
                  </div>
                  <div>
                     <span className="dl-label">SMS Consent:</span>{" "}
                     <span className="dl-value">{info["SMS Consent"] || "N/A"}</span>
                  </div>
               </div>
            </div>
            <style jsx>{`
               .driver-license-card.dl-horizontal {
                  max-width: 98%;
                  min-width: 600px;
                  margin-left: auto;
                  margin-right: auto;
                  margin-bottom: 28px;
                  border-radius: 22px;
                  box-shadow:
                     0 8px 40px rgba(37, 99, 235, 0.1),
                     0 1.5px 8px rgba(0, 0, 0, 0.07);
                  background: linear-gradient(120deg, #f0f4ff 60%, #e0e7ff 100%);
                  border: 2.5px solid #2563eb;
                  overflow: hidden;
                  font-family: "Segoe UI", "Arial", sans-serif;
                  transition: box-shadow 0.2s;
               }
               .driver-license-card.dl-horizontal:hover {
                  box-shadow:
                     0 12px 48px rgba(37, 99, 235, 0.18),
                     0 2px 12px rgba(0, 0, 0, 0.1);
               }
               .dl-header {
                  background: linear-gradient(90deg, #2563eb 60%, #60a5fa 100%);
                  color: #fff;
                  padding: 22px 0 14px 0;
                  text-align: center;
               }
               .dl-title {
                  font-size: 1.45rem;
                  font-weight: 800;
                  letter-spacing: 2.5px;
               }
               .dl-body {
                  display: flex;
                  align-items: center;
                  padding: 32px 38px 32px 38px;
                  gap: 38px;
               }
               .dl-avatar {
                  flex: 0 0 80px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 0;
                  margin-right: 18px;
               }
               .dl-avatar svg {
                  display: block;
                  width: 70px;
                  height: 70px;
               }
               .dl-info-grid {
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  gap: 18px 48px;
                  width: 100%;
               }
               .dl-label {
                  font-weight: 700;
                  color: #2563eb;
                  font-size: 1.05em;
               }
               .dl-value {
                  color: #22223b;
                  font-size: 1.05em;
                  font-weight: 500;
               }
               .dl-badge {
                  display: inline-block;
                  padding: 3px 16px;
                  border-radius: 14px;
                  font-size: 1em;
                  font-weight: 700;
               }
               .dl-badge-yes {
                  background: #d1fae5;
                  color: #065f46;
               }
               .dl-badge-no {
                  background: #fee2e2;
                  color: #991b1b;
               }
               @media (max-width: 900px) {
                  .driver-license-card.dl-horizontal {
                     min-width: 0;
                     max-width: 98vw;
                  }
                  .dl-body {
                     flex-direction: column;
                     align-items: center;
                     padding: 24px 10px 24px 10px;
                     gap: 18px;
                  }
                  .dl-info-grid {
                     grid-template-columns: 1fr;
                     gap: 12px 0;
                  }
               }
            `}</style>
         </div>
      );
   }

   return (
      <div>
         <style jsx>{`
            .modal-overlay {
               position: fixed;
               top: 0;
               left: 0;
               right: 0;
               bottom: 0;
               background: rgba(0, 0, 0, 0.7);
               display: flex;
               justify-content: center;
               align-items: center;
               z-index: 1000;
               padding: 20px;
            }
            .modal-content.info-modal {
               background: white;
               border-radius: 16px;
               box-shadow: 0 25px 60px rgba(0, 0, 0, 0.3);
               max-width: 1000px;
               width: 100%;
               max-height: 90vh;
               display: flex;
               flex-direction: column;
               position: relative;
               /* Remove overflow: hidden; to allow scroll */
            }
            .close-button {
               position: absolute;
               top: 50%;
               right: 24px;
               transform: translateY(-50%);
               background: rgba(255, 255, 255, 0.9);
               border: none;
               font-size: 24px;
               cursor: pointer;
               color: #374151;
               width: 36px;
               height: 36px;
               border-radius: 50%;
               display: flex;
               align-items: center;
               justify-content: center;
               transition: all 0.2s ease;
               z-index: 10;
               box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
               backdrop-filter: blur(4px);
            }
            .close-button:hover {
               background: rgba(255, 255, 255, 1);
               color: #1e293b;
               transform: translateY(-50%) scale(1.1);
               box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }
            .modal-body {
               background: #f4f6fb !important;
               padding: 32px 32px 32px 32px;
               border-radius: 0 0 16px 16px;
            }
            .card {
               background: white;
               border-radius: 20px;
               box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
               overflow: hidden;
               transition: all 0.3s ease;
               border: 1px solid #e2e8f0;
            }
            .card-header {
               padding: 25px;
               background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
               color: white;
               display: flex;
               justify-content: space-between;
               align-items: center;
               position: relative;
            }
            .driver-verification-card .card-header {
               background: #2563eb;
            }
            .dispatch-card .card-header {
               background: #6c3fc5;
            }
            .card-header h3 {
               margin: 0;
               font-size: 1.6em;
               font-weight: 700;
            }
            .card-body {
               padding: 32px;
            }
            .info-section {
               background: #fff;
               border: 1.5px solid #e0e7ef;
               border-radius: 14px;
               margin-bottom: 28px;
               padding: 28px 24px 20px 24px;
               box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
               max-width: 98%;
               margin-left: auto;
               margin-right: auto;
            }
            .info-section h4 {
               font-size: 1.15rem;
               font-weight: 700;
               margin-bottom: 18px;
               /* color is now set inline */
               border-bottom: 1px solid #e0e7ef;
               padding-bottom: 8px;
            }
            .info-details p {
               margin: 12px 0;
               color: #475569;
               line-height: 1.6;
               font-size: 0.95em;
            }
            .documents-grid {
               display: flex;
               flex-wrap: wrap;
               gap: 20px;
               align-items: flex-start;
            }
            .document-image-container {
               display: flex;
               flex-direction: column;
               align-items: center;
            }
            .document-image-header {
               display: flex;
               align-items: center;
               gap: 8px;
               margin-bottom: 8px;
            }
            .document-image-header h5 {
               margin: 0;
               font-size: 0.9rem;
               font-weight: 600;
               color: #374151;
            }
            .expand-button {
               background: #3b82f6;
               color: white;
               border: none;
               border-radius: 4px;
               padding: 2px 6px;
               font-size: 0.8rem;
               cursor: pointer;
               transition: background-color 0.2s ease;
            }
            .expand-button:hover {
               background: #2563eb;
            }
            .document-image {
               width: 120px;
               height: 80px;
               object-fit: cover;
               border-radius: 6px;
               border: 1px solid #e5e7eb;
               cursor: pointer;
               transition: transform 0.2s ease;
            }
            .document-image:hover {
               transform: scale(1.05);
            }
            .image-error {
               display: flex;
               flex-direction: column;
               align-items: center;
               justify-content: center;
               width: 120px;
               height: 80px;
               background: #f3f4f6;
               border-radius: 6px;
               border: 1px solid #e5e7eb;
               font-size: 0.8rem;
               color: #6b7280;
            }
            .verification-grid {
               display: grid;
               grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
               gap: 20px;
            }
            .verification-item {
               background: white;
               border-radius: 8px;
               padding: 16px;
               border: 1px solid #e5e7eb;
            }
            .verification-item h5 {
               margin-top: 0;
               margin-bottom: 12px;
               font-size: 1rem;
               font-weight: 600;
               color: #374151;
            }
            .verification-status {
               font-weight: 600;
               padding: 2px 8px;
               border-radius: 12px;
               font-size: 0.8rem;
            }
            .verification-status.success {
               background: #d1fae5;
               color: #065f46;
            }
            .verification-status.failed {
               background: #fee2e2;
               color: #991b1b;
            }
            .status-indicator {
               font-weight: 600;
               padding: 2px 8px;
               border-radius: 12px;
               font-size: 0.8rem;
            }
            .status-indicator.empty {
               background: #d1fae5;
               color: #065f46;
            }
            .status-indicator.occupied {
               background: #fef3c7;
               color: #92400e;
            }
            .consent-status {
               font-weight: 600;
               padding: 2px 8px;
               border-radius: 12px;
               font-size: 0.8rem;
            }
            .consent-status.approved {
               background: #d1fae5;
               color: #065f46;
            }
            .consent-status.denied {
               background: #fee2e2;
               color: #991b1b;
            }
            .badge {
               font-size: 0.75rem;
               font-weight: 600;
               padding: 0.4em 0.8em;
               border-radius: 20px;
               letter-spacing: 0.3px;
               display: inline-flex;
               align-items: center;
            }
            .badge-primary {
               background-color: #cddcff;
               color: #0042d4;
            }
            .badge-secondary {
               background-color: #e9ecef;
               color: #495057;
            }
            .badge-success {
               background-color: #c3e6cb;
               color: #155724;
            }
            .badge-danger {
               background-color: #f5c6cb;
               color: #721c24;
            }
            .badge-warning {
               background-color: #ffeeba;
               color: #856404;
            }
            .badge-info {
               background-color: #bee5eb;
               color: #0c5460;
            }
            .section-card {
               border: 1px solid #e2e8f0;
               border-radius: 12px;
               overflow: hidden;
               margin-bottom: 15px;
               background: #f9fafb;
            }
            .section-header {
               padding: 15px 20px;
               cursor: pointer;
               display: flex;
               align-items: center;
               justify-content: space-between;
               background: #f0f2f5;
            }
            .section-header:hover {
               background: #e9ecef;
            }
            .section-title {
               margin-bottom: 0;
               font-size: 1em;
               font-weight: 600;
               color: #374151;
            }
            .chevron {
               transition: transform 0.3s ease;
            }
            .chevron-open {
               transform: rotate(90deg);
            }
            .section-body {
               padding: 15px 20px;
               border-top: 1px solid #e2e8f0;
            }
            .data-card {
               border: 1px solid #e2e8f0;
               border-radius: 12px;
               overflow: hidden;
               background: #f9fafb;
            }
            .field-card {
               border: 1px solid #e2e8f0;
               border-radius: 12px;
               overflow: hidden;
               background: #f9fafb;
            }
            .icon-container {
               display: flex;
               align-items: center;
               justify-content: center;
               width: 40px;
               height: 40px;
               border-radius: 10px;
               background: #e0e7ff;
            }
            .icon-container svg {
               width: 20px;
               height: 20px;
               color: #4f46e5;
            }
            .field-icon {
               width: 20px;
               height: 20px;
               display: flex;
               align-items: center;
               justify-content: center;
            }
            .field-label {
               font-size: 0.95em;
               font-weight: 600;
               color: #374151;
            }
            .field-value {
               font-size: 1em;
               color: #343a40;
            }
            code {
               background: #f1f5f9;
               padding: 2px 6px;
               border-radius: 4px;
               font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
               font-size: 0.85em;
               color: #475569;
            }
            .driver-card-desktop {
               display: block;
            }
            .driver-info-mobile {
               display: none;
            }
            /* Mobile driver info title */
            @media (max-width: 700px) {
               .driver-info-mobile-title {
                  display: block;
                  font-size: 1.15rem;
                  font-weight: 700;
                  color: #2563eb;
                  margin-bottom: 10px;
                  margin-left: 2px;
               }
            }
            @media (max-width: 700px) {
               .verification-grid {
                  grid-template-columns: 1fr !important;
               }
               .driver-card-desktop {
                  display: none;
               }
               .driver-info-mobile {
                  display: block;
                  background: #fff;
                  border: 1.5px solid #e0e7ef;
                  border-radius: 14px;
                  margin-bottom: 28px;
                  padding: 20px 16px;
                  font-size: 1em;
                  max-width: 98%;
                  margin-left: auto;
                  margin-right: auto;
               }
               .driver-info-mobile ul {
                  list-style: none;
                  padding: 0;
                  margin: 0;
               }
               .driver-info-mobile li {
                  margin-bottom: 10px;
                  color: #22223b;
               }
               .driver-info-mobile b {
                  color: #2563eb;
               }
               /* Ensure verification items wrap text on small screens */
               .verification-item {
                  word-break: break-word;
                  white-space: normal;
                  overflow-wrap: break-word;
                  max-width: 100%;
               }
               .verification-item p,
               .verification-item span,
               .verification-item strong,
               .verification-item code {
                  word-break: break-word;
                  white-space: normal;
                  overflow-wrap: break-word;
                  max-width: 100%;
               }
            }
            .info-section.driver-theme {
               border: 2.5px solid #2563eb !important;
            }
            .info-section.dispatch-theme {
               border: 2.5px solid #6c3fc5 !important;
            }
         `}</style>
         <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content info-modal" onClick={(e) => e.stopPropagation()}>
               <div className="modal-body">
                  <div
                     className={`card ${isDriverVerification ? "driver-verification-card" : "dispatch-card"}`}
                  >
                     <div className="card-header">
                        <h3>{formatFormType(selectedForm.form_type)}</h3>
                        <button className="close-button" onClick={onClose} aria-label="Close">
                           ×
                        </button>
                     </div>
                     <div className="card-body">
                        <div className="verification-layout">
                           {/* Driver Information Section */}
                           {isDriverVerification ? (
                              <>
                                 <div className="driver-card-desktop">
                                    <DriverLicenseCard info={getDriverInfoFields()} />
                                 </div>
                                 <div className="driver-info-mobile">
                                    <div className="driver-info-mobile-title">Driver Info</div>
                                    <ul>
                                       <li>
                                          <b>Name:</b> {getDriverInfoFields()["Driver First Name"]}{" "}
                                          {getDriverInfoFields()["Driver Last Name"]}
                                       </li>
                                       <li>
                                          <b>Email:</b>{" "}
                                          {getDriverInfoFields()["Driver Email"] || "Not Provided"}
                                       </li>
                                       <li>
                                          <b>Phone:</b>{" "}
                                          {getDriverInfoFields()["Driver Phone"] || "N/A"}
                                       </li>
                                       <li>
                                          <b>Location:</b>{" "}
                                          {(() => {
                                             const location = getDriverInfoFields()["Location"];
                                             if (!location || typeof location !== "string")
                                                return "N/A";
                                             const match = location.match(
                                                /Lat:\s*([\d.-]+),\s*Lng:\s*([\d.-]+)/i
                                             );
                                             if (!match) return location;
                                             const lat = parseFloat(match[1]).toFixed(2);
                                             const lng = parseFloat(match[2]).toFixed(2);
                                             return `Lat: ${lat}, Lng: ${lng}`;
                                          })()}
                                       </li>
                                       <li>
                                          <b>Empty Status:</b>{" "}
                                          {getDriverInfoFields()["Empty Status"] || "N/A"}
                                       </li>
                                       <li>
                                          <b>Empty Time:</b>{" "}
                                          {getDriverInfoFields()["Empty Time"] || "N/A"}
                                       </li>
                                       <li>
                                          <b>Empty Location:</b>{" "}
                                          {getDriverInfoFields()["Empty Location"] || "N/A"}
                                       </li>
                                       <li>
                                          <b>SMS Consent:</b>{" "}
                                          {getDriverInfoFields()["SMS Consent"] || "N/A"}
                                       </li>
                                    </ul>
                                 </div>
                              </>
                           ) : (
                              renderInfoSection(
                                 "Driver Information",
                                 getDriverInfoFields(),
                                 icons.user,
                                 isDispatch ? "#6c3fc5" : "#2563eb"
                              )
                           )}
                           {/* Dispatcher Information Section (for dispatch forms) */}
                           {isDispatch &&
                              renderInfoSection(
                                 "Dispatcher Information",
                                 getDispatcherInfoFields(),
                                 icons.user,
                                 "#6c3fc5"
                              )}
                           {/* Equipment Information Section (for dispatch forms) */}
                           {isDispatch &&
                              renderInfoSection(
                                 "Equipment Information",
                                 getEquipmentInfoFields(),
                                 icons.truck,
                                 "#6c3fc5"
                              )}
                           {/* Documents Section */}
                           {renderDocumentsSection(isDispatch ? "#6c3fc5" : "#2563eb")}
                           {/* Verification Results Section */}
                           {renderVerificationSection(isDispatch ? "#6c3fc5" : "#2563eb")}
                           {/* Meta & Identifiers Section */}
                           {renderInfoSection(
                              "Meta & Identifiers",
                              getMetaFields(),
                              icons.document,
                              isDispatch ? "#6c3fc5" : "#2563eb"
                           )}
                        </div>
                     </div>
                  </div>
                  {/* Expanded Image Modal */}
                  {expandedImage && (
                     <div className="modal-overlay" onClick={() => setExpandedImage(null)}>
                        <div
                           className="modal-content info-modal"
                           onClick={(e) => e.stopPropagation()}
                        >
                           <button className="close-button" onClick={() => setExpandedImage(null)}>
                              ×
                           </button>
                           <div className="modal-body" style={{ textAlign: "center" }}>
                              <h3>{expandedImage.title}</h3>
                              <img
                                 src={expandedImage.url}
                                 alt={expandedImage.title}
                                 style={{
                                    maxWidth: "100%",
                                    maxHeight: "70vh",
                                    borderRadius: 10,
                                 }}
                              />
                           </div>
                        </div>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default FormModal;
